import apiClient from '../../../Services/ApiClient';
import { formatQueryString } from '../../../Services/Api/FormatQueryString';
import type { SearchMedicamentRecordPatientFormValues } from '../SearchMedicamentRecord/SearchMedicamentRecordPatientsDataFormScheme';

export const prepareQueryParameters = (
	filterData: SearchMedicamentRecordPatientFormValues,
	extra?: Record<string, string | number | undefined>,
) => {
	const {
		firstName,
		lastName,
		dateOfBirth,
		months,
		useAddress,
		address,
		useDocument,
		identificationDocument,
	} = filterData;

	return formatQueryString({
		firstName,
		lastName,
		dateOfBirth,
		months: months?.value || months,
		atc: 5,
		...(useAddress && address),
		...(useDocument && {
			documentNumber: identificationDocument?.documentNumber,
			documentType: identificationDocument?.documentType?.value,
			documentHolder: identificationDocument?.documentHolder?.value,
		}),
		version: 2,
		...extra,
	});
};

export async function fetchMedicamentRecordReissueDefaults(
	filterData: SearchMedicamentRecordPatientFormValues,
	predpisId: string,
) {
	const query = prepareQueryParameters(filterData, { predpisId });

	const response = await apiClient.get(
		`/erecept/lekovy-zaznam/reissue-defaults?${query}`,
		{ catchError: false },
	);

	const payload = response?.data?.data ?? response?.data;

	if (!payload?.formData?.default?.medicaments) {
		return null;
	}

	return payload;
}
